(function () {
  'use strict';

  if (window.LuxsterCatalogMenuController) {
    window.LuxsterCatalogMenuController.init();
    return;
  }

  var desktop = window.matchMedia('(min-width: 1200px)');
  var hover = window.matchMedia('(hover: hover) and (pointer: fine)');
  var entries = [];
  var active = null;
  var closeTimer = null;
  var nextId = 0;
  var drawer = null;
  var scrollLock = null;
  var boundHeaders = new WeakSet();
  var boundOtherItems = new WeakSet();
  var boundDrawers = new WeakSet();

  function clearCloseTimer() {
    window.clearTimeout(closeTimer);
    closeTimer = null;
  }

  function setOpen(entry, open) {
    clearCloseTimer();
    if (open) {
      entries.forEach(function (other) {
        if (other !== entry) {
          other.details.open = false;
          other.summary.setAttribute('aria-expanded', 'false');
        }
      });
    }
    entry.details.open = open;
    entry.summary.setAttribute('aria-expanded', String(open));
    if (open) active = entry;
    else if (active === entry) active = null;
  }

  function closeAll() {
    clearCloseTimer();
    entries.forEach(function (entry) {
      entry.details.open = false;
      entry.summary.setAttribute('aria-expanded', 'false');
    });
    active = null;
  }

  function lockScroll() {
    if (scrollLock) return;
    var body = document.body;
    var props = ['position', 'top', 'left', 'right', 'width', 'overflow', 'padding-right'];
    var section = drawer.opener.closest('#shopify-section-header');
    var sticky = section && /^(sticky|-webkit-sticky)$/.test(window.getComputedStyle(section).position);
    scrollLock = { x: window.scrollX, y: window.scrollY, styles: {}, header: null, observer: null };
    if (sticky) {
      scrollLock.header = { element: section, top: section.getBoundingClientRect().top, offset: 0, styles: {} };
      ['position', 'top'].forEach(function (name) {
        scrollLock.header.styles[name] = [section.style.getPropertyValue(name), section.style.getPropertyPriority(name)];
      });
      // Keep the header in flow. A transform would change the fixed drawer's containing block.
      section.style.setProperty('position', 'relative', 'important');
      section.style.setProperty('top', '0px', 'important');
    }
    props.forEach(function (name) {
      scrollLock.styles[name] = [body.style.getPropertyValue(name), body.style.getPropertyPriority(name)];
    });
    body.style.setProperty('position', 'fixed');
    // Override the legacy body top: 0 !important rule while preserving its original inline priority.
    body.style.setProperty('top', (-scrollLock.y) + 'px', 'important');
    body.style.setProperty('left', '0');
    body.style.setProperty('right', '0');
    body.style.setProperty('width', '100%');
    body.style.setProperty('overflow', 'hidden');
    document.documentElement.classList.add('luxster-mobile-menu-open');
    if (scrollLock.header) {
      var pinned = scrollLock.header;
      pinned.offset = pinned.top - pinned.element.getBoundingClientRect().top;
      pinned.element.style.setProperty('top', pinned.offset + 'px', 'important');
    }
    if (window.ResizeObserver) {
      scrollLock.observer = new ResizeObserver(positionDrawer);
      scrollLock.observer.observe(drawer.opener.closest('header'));
      var announcement = drawer.opener.closest('header').querySelector('.top-header');
      if (announcement) scrollLock.observer.observe(announcement);
    }
  }

  function unlockScroll() {
    if (!scrollLock) return;
    var saved = scrollLock;
    scrollLock = null;
    if (saved.observer) saved.observer.disconnect();
    if (saved.header) {
      Object.keys(saved.header.styles).forEach(function (name) {
        var value = saved.header.styles[name];
        if (value[0]) saved.header.element.style.setProperty(name, value[0], value[1]);
        else saved.header.element.style.removeProperty(name);
      });
    }
    Object.keys(saved.styles).forEach(function (name) {
      var value = saved.styles[name];
      if (value[0]) document.body.style.setProperty(name, value[0], value[1]);
      else document.body.style.removeProperty(name);
    });
    document.documentElement.classList.remove('luxster-mobile-menu-open');
    window.scrollTo({ left: saved.x, top: saved.y, behavior: 'instant' });
    if (window.LuxsterHeaderHeightSync) window.LuxsterHeaderHeightSync.sync();
  }

  function stopDrawerAnimation(clip) {
    if (!drawer || !drawer.motion) return;
    if (clip) drawer.panel.style.setProperty('clip-path', clip);
    drawer.motion.onfinish = null;
    drawer.motion.cancel();
    drawer.motion = null;
  }

  function drawerClip() {
    if (!drawer.panel.classList.contains('show')) return 'inset(0 0 100% 0)';
    var clip = window.getComputedStyle(drawer.panel).clipPath;
    return clip && clip !== 'none' ? clip : 'inset(0 0 0 0)';
  }

  function animateDrawer(from, to, finish) {
    drawer.panel.style.setProperty('clip-path', from);
    if (!drawer.panel.animate || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      drawer.panel.style.removeProperty('clip-path');
      if (finish) finish();
      return;
    }
    var animation = drawer.panel.animate([{ clipPath: from }, { clipPath: to }], {
      duration: 220,
      easing: 'cubic-bezier(0.22, 0.61, 0.36, 1)',
      fill: 'both'
    });
    drawer.motion = animation;
    animation.onfinish = function () {
      if (drawer.motion !== animation) return;
      drawer.motion = null;
      if (finish) finish();
      drawer.panel.style.removeProperty('clip-path');
      animation.cancel();
    };
  }

  function finishClosingDrawer(restoreFocus, wasOpen) {
    drawer.closing = false;
    drawer.panel.classList.remove('show', 'collapsing');
    drawer.panel.classList.add('collapse');
    drawer.panel.style.removeProperty('clip-path');
    drawer.panel.style.removeProperty('height');
    drawer.opener.closest('header').classList.remove('active');
    drawer.panel.removeAttribute('aria-modal');
    drawer.panel.removeAttribute('role');
    if (desktop.matches) drawer.panel.removeAttribute('inert');
    else drawer.panel.setAttribute('inert', '');
    closeAll();
    // Restore the underlying page before the next interaction can scroll it.
    unlockScroll();
    if (restoreFocus && wasOpen && drawer.opener.isConnected) drawer.opener.focus({ preventScroll: true });
  }

  function closeDrawer(restoreFocus, immediate) {
    if (!drawer) return;
    var wasOpen = drawer.open;
    var visible = drawer.panel.classList.contains('show');
    var from = drawerClip();
    stopDrawerAnimation(from);
    drawer.open = false;
    drawer.opener.setAttribute('aria-expanded', 'false');
    drawer.opener.setAttribute('aria-label', drawer.opener.getAttribute('data-menu-open-label'));
    drawer.panel.setAttribute('inert', '');
    if (!immediate && wasOpen && visible) {
      drawer.closing = true;
      animateDrawer(from, 'inset(0 0 100% 0)', function () { finishClosingDrawer(restoreFocus, wasOpen); });
    } else {
      finishClosingDrawer(restoreFocus, wasOpen);
    }
  }

  function positionDrawer() {
    if (!drawer || (!drawer.open && !drawer.closing)) return;
    var header = drawer.opener.closest('header');
    if (scrollLock && scrollLock.header) {
      var pinned = scrollLock.header;
      var naturalTop = pinned.element.getBoundingClientRect().top - pinned.offset;
      var announcement = header.querySelector('.top-header');
      var stickyTop = announcement ? -announcement.getBoundingClientRect().height : 0;
      // Reproduce the sticky position while body is fixed, including announcement reflow on rotation.
      pinned.offset = Math.max(naturalTop, stickyTop) - naturalTop;
      pinned.element.style.setProperty('top', pinned.offset + 'px', 'important');
    }
    var viewport = window.visualViewport;
    var viewportTop = viewport ? viewport.offsetTop : 0;
    var viewportBottom = viewportTop + (viewport ? viewport.height : window.innerHeight);
    var navigation = header.querySelector('.middle-header') || header;
    var top = Math.max(viewportTop, Math.min(viewportBottom, navigation.getBoundingClientRect().bottom));
    drawer.panel.style.setProperty('--luxster-mobile-menu-top', top + 'px');
    drawer.panel.style.setProperty('--luxster-mobile-menu-height', Math.max(0, viewportBottom - top) + 'px');
    if (window.LuxsterHeaderHeightSync) window.LuxsterHeaderHeightSync.sync();
  }

  function openDrawer() {
    if (!drawer || desktop.matches) return;
    var from = drawerClip();
    stopDrawerAnimation(from);
    closeAll();
    drawer.closing = false;
    drawer.open = true;
    drawer.panel.classList.remove('collapsing');
    drawer.panel.classList.add('collapse');
    drawer.panel.style.removeProperty('height');
    drawer.panel.setAttribute('role', 'region');
    // Complete the scroll/header layout while the drawer is still hidden.
    // Its first visible layout and the icon animation must use the final geometry.
    lockScroll();
    positionDrawer();
    drawer.panel.removeAttribute('inert');
    drawer.panel.classList.add('show');
    drawer.opener.setAttribute('aria-expanded', 'true');
    drawer.opener.setAttribute('aria-label', drawer.opener.getAttribute('data-menu-close-label'));
    animateDrawer(from, 'inset(0 0 0 0)');
    drawer.close.focus({ preventScroll: true });
  }

  function initDrawer(header) {
    var panel = header.querySelector('#navbarSidetoggle');
    var opener = header.querySelector('.side_navbar_toggler');
    var close = opener;
    if (!panel || !opener || !close || boundDrawers.has(panel)) return;
    if (drawer && drawer.panel !== panel) closeDrawer(false, true);
    boundDrawers.add(panel);
    drawer = { panel: panel, opener: opener, close: close, open: false, closing: false, motion: null };
    opener.removeAttribute('data-toggle');
    opener.removeAttribute('data-target');
    opener.setAttribute('aria-controls', panel.id);
    opener.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      if (drawer.open) closeDrawer(true);
      else openDrawer();
    });
    panel.addEventListener('click', function (event) {
      event.stopPropagation();
      var anchor = event.target.closest('a[href]');
      if (anchor && anchor.getAttribute('href') && anchor.getAttribute('href') !== '#') closeDrawer(false);
    });
    closeDrawer(false, true);
  }

  function scheduleClose(entry) {
    clearCloseTimer();
    closeTimer = window.setTimeout(function () {
      closeTimer = null;
      if (active === entry) setOpen(entry, false);
    }, 180);
  }

  function canHover(event) {
    return desktop.matches && hover.matches && event.pointerType === 'mouse';
  }

  function init() {
    entries = entries.filter(function (entry) { return entry.item.isConnected; });
    if (active && !active.item.isConnected) active = null;
    if (drawer && !drawer.panel.isConnected) {
      closeDrawer(false, true);
      drawer = null;
    }
    document.querySelectorAll('header.header_custom').forEach(initDrawer);
    document.querySelectorAll('header.header_custom [data-catalog-menu]').forEach(function (item) {
      if (item.dataset.catalogReady === 'true') return;
      var details = item.querySelector('details');
      var summary = details && details.querySelector('summary');
      var panel = details && details.querySelector('.luxster-catalog-menu__panel');
      var header = item.closest('header.header_custom');
      if (!details || !summary || !panel || !header) return;
      item.dataset.catalogReady = 'true';
      if (!panel.id) panel.id = 'LuxsterCatalogMenu-' + (++nextId);
      summary.setAttribute('aria-controls', panel.id);
      summary.setAttribute('aria-expanded', String(details.open));
      var entry = { item: item, details: details, summary: summary, panel: panel, header: header };
      entries.push(entry);
      summary.addEventListener('click', function (event) {
        event.preventDefault();
        setOpen(entry, !details.open);
      });
      summary.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
        event.preventDefault();
        setOpen(entry, true);
        var links = panel.querySelectorAll('a[href]');
        var target = event.key === 'ArrowUp' ? links[links.length - 1] : links[0];
        if (target) target.focus({ preventScroll: true });
      });
      details.addEventListener('toggle', function () {
        summary.setAttribute('aria-expanded', String(details.open));
        if (details.open && active !== entry) setOpen(entry, true);
        else if (!details.open && active === entry) active = null;
      });
      item.addEventListener('pointerenter', function (event) {
        if (canHover(event)) setOpen(entry, true);
      });
      item.addEventListener('pointerleave', function (event) {
        if (!canHover(event) || !details.open) return;
        if (event.relatedTarget instanceof Node && header.contains(event.relatedTarget)) {
          clearCloseTimer();
          return;
        }
        scheduleClose(entry);
      });
      panel.addEventListener('pointerenter', clearCloseTimer);
      if (!boundHeaders.has(header)) {
        boundHeaders.add(header);
        header.addEventListener('pointerenter', function (event) {
          if (canHover(event)) clearCloseTimer();
        });
        header.addEventListener('pointerleave', function (event) {
          if (canHover(event) && active && active.header === header) scheduleClose(active);
        });
      }
      header.querySelectorAll('#navbarSidetoggle > .navbar-nav > li:not([data-catalog-menu])').forEach(function (otherItem) {
        if (boundOtherItems.has(otherItem)) return;
        boundOtherItems.add(otherItem);
        otherItem.addEventListener('pointerenter', function (event) {
          if (canHover(event)) closeAll();
        });
      });
    });
  }

  document.addEventListener('pointerdown', function (event) {
    var target = event.target instanceof Element ? event.target : null;
    if (!target) return;
    if (drawer && drawer.open && !drawer.panel.contains(target) && !drawer.opener.contains(target)) closeDrawer(false);
    // Keep in-flow mobile grids stable until the pressed control activates.
    if (!desktop.matches) return;
    if (!active) return;
    if (target.closest('[data-header-search-toggle], [data-vehicle-toggle], .side_navbar_toggler, .cart_trigger')) {
      closeAll();
      return;
    }
    if (!active.item.contains(target) && !target.closest('[data-catalog-menu]')) closeAll();
  }, true);

  document.addEventListener('click', function (event) {
    var target = event.target instanceof Element ? event.target : null;
    if (target && drawer && drawer.open && !drawer.panel.contains(target) && !drawer.opener.contains(target)) closeDrawer(false);
  }, true);

  document.addEventListener('click', function (event) {
    var target = event.target instanceof Element ? event.target : null;
    if (!target || !active) return;
    if (target.closest('[data-header-search-toggle], [data-vehicle-toggle], .side_navbar_toggler, .cart_trigger')) {
      closeAll();
      return;
    }
    if (!active.item.contains(target) && !target.closest('[data-catalog-menu]')) closeAll();
  });

  document.addEventListener('keydown', function (event) {
    if (event.defaultPrevented) return;
    if (drawer && drawer.open && event.key === 'Tab') {
      var focusable = Array.from(drawer.opener.closest('header').querySelectorAll('a[href], button:not([disabled]), summary, input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])')).filter(function (element) {
        return element.getClientRects().length && !element.closest('[hidden], [inert]');
      });
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
    if (event.key !== 'Escape') return;
    if (active) {
      var entry = active;
      event.preventDefault();
      closeAll();
      entry.summary.focus({ preventScroll: true });
    } else if (drawer && drawer.open) {
      event.preventDefault();
      closeDrawer(true);
    }
  });

  document.addEventListener('focusin', function (event) {
    if (drawer && (drawer.open || drawer.closing) && !drawer.opener.closest('header').contains(event.target)) {
      drawer.close.focus({ preventScroll: true });
      return;
    }
    // Focusing another drawer control must not move it before pointerup.
    if (drawer && (drawer.open || drawer.closing) && !desktop.matches && (drawer.panel.contains(event.target) || drawer.opener.contains(event.target))) return;
    if (active && !active.item.contains(event.target) && !event.target.closest('[data-catalog-menu]')) closeAll();
  });

  desktop.addEventListener('change', function () { closeDrawer(false, true); closeAll(); });
  hover.addEventListener('change', closeAll);
  window.addEventListener('resize', positionDrawer);
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', positionDrawer);
    window.visualViewport.addEventListener('scroll', positionDrawer);
  }
  window.addEventListener('pagehide', function () { closeDrawer(false, true); closeAll(); });
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', function () { closeDrawer(false, true); closeAll(); });

  window.LuxsterCatalogMenuController = { init: init, close: closeAll, closeDrawer: closeDrawer };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
}());

